module.exports = __webpack_public_path__ + "nato.0ade7442.svg";